
import Markdown from 'react-markdown';

interface MarkdownRendererProps {
  content: string;
}

export function MarkdownRenderer({ content }: MarkdownRendererProps) {
  // Normalize literal \n escape sequences into real newlines.
  // The LLM occasionally double-escapes newlines in structured JSON output,
  // resulting in literal \n characters instead of actual line breaks.
  const normalizedContent = content.replace(/\\n/g, '\n');

  return (
    <div className="markdown-content prose prose-neutral dark:prose-invert max-w-none">
      <Markdown>{normalizedContent}</Markdown>
    </div>
  );
}
